import styled, { keyframes } from "styled-components";
import { device } from "common/src/styles/Reset";

const fadeIn = keyframes`
  from {
    width:auto;
    transform: scale(.25);
    opacity: 0;
  }

  to {
    width:auto;
    transform: scale(1);
    opacity: 1;
  }
`;

export const ButtonContainer = styled.div`
  text-align: center;
  clear: both;
  opacity: 0;
  animation: ${fadeIn} 1s ease-in-out;
  animation-fill-mode: both;
  animation-delay: ${(props) => props.delay}s;
  transform-origin: 0 50% 0;
  border-top: 1px dashed #d4d4d4;
  padding: 10px;

  &.likert{display:flex; align-items:center;justify-content:center}
  @media ${device.laptop} {
    padding-top: 20px;
    padding-bottom: 20px;
  }

  > img {
    max-height: 100px;
    border-radius: 10px 10px 0 10px;
  }
  > button.button-gif,
  > button.button-gif:hover {
    background-color: transparent;
    border: 6px solid #e4efe8;
    padding: 0;
  }
  > button.gif,
  > button.button-gif {
    max-width: 200px;
  }
`;

export const LegendWrapper = styled.div`
width:${props=>props.totalButtons*100/2}px !important;
margin:0 auto;
font-size:11px;
font-weight:bold;
padding:0 20px;
animation: ${fadeIn} 1s ease-in-out;
  animation-fill-mode: both;
  animation-delay: ${(props) => props.delay}s;
p{text-align:right;width:50%;display:inline-block;text-transform:uppercase;color:${(props) => props.theme.themeGlobal.positive}}
p:first-child{text-align:left; color:${(props) => props.theme.themeGlobal.negative};padding-left:5px}
`